import React, { useEffect, useMemo, useRef } from "react"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core"
import SvgIcon from "@material-ui/core/SvgIcon"

const parsableTypes = ["text/html", "text/xml", "application/xml", "application/xhtml+xml", "image/svg+xml"]

const parser = new DOMParser();

function svgFromBase64(str, mimeType) {
  const decoded = decodeURIComponent(escape(window.atob(str.split(`data:${mimeType};base64,`)[1])))
  return parser.parseFromString(decoded, mimeType)
}

function Wrapper(props) {

  const {
    className,
    src,
    mimeType,
    alt,
    children,
    ...rest
  } = props

  const container = useRef()

  const classes = styles()

  const DomNode = useMemo(() => {
    if (typeof src === "string" && parsableTypes.includes(mimeType)) {
      return svgFromBase64(src, mimeType)
    }
    return null
  }, [mimeType, src])

  const reactElement = useMemo(() => {
    if (DomNode) {
      return React.createElement(
        "svg",
        Object.fromEntries(Array.from(DomNode.rootElement.attributes, ({ name, value }) => [name, value]))
      )
    }
    return null
  }, [DomNode])

  useEffect(() => {
    const element = container.current
    if (DomNode) {
      Array.from(DomNode.rootElement.children).forEach(childNode => {
        element.appendChild(childNode)
      })
    }
  }, [DomNode])

  return (
    <SvgIcon
      component="span"
      className={clsx(classes.icon, className)}
      {...rest}
    >
      {reactElement ? React.cloneElement(reactElement, {
        ref: container,
        className: classes.img,
        fill: "currentColor"
      }) : (
        <img className={classes.img}
          src={src}
          alt={alt || ""}
        />
      )}
    </SvgIcon>
  )
}

const styles = makeStyles(theme => ({
  icon: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    userSelect: "none",
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
    margin: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
  img: {
    verticalAlign: "middle",
    alignSelf: "center",
    maxWidth: theme.typography.pxToRem(24),
    maxHeight: theme.typography.pxToRem(18)
  }
}))

export default Wrapper